export default "__VITE_ASSET__DqlJCjo7__"